<template>
  <DragTable
    @drag-add="dragAdd"
    class="routine-table"
    v-model="dataExercises"
    group="routine"
    handle=".handle-td"
    placeholder="Sin ejercicios"
    ref="table"
  >
    <template v-slot:header>
      <div class="flex-th table-title">
        {{ title }}
        <div class="routine-btnbar-group right-group">
          <b-button :id="routine + 'hiit-button'" @click="addCircuit" variant="light">+</b-button>
          <b-tooltip :target="routine + 'hiit-button'" triggers="hover" placement="left">
            Agregar circuito
          </b-tooltip>
        </div>
      </div>
      <div class="flex-trow flex-trow-header">
        <div class="flex-th circuit-th">Tipo</div>
        <div class="flex-th name-th">Ejercicio</div>
        <div class="flex-th observation-th">Observación</div>
        <div class="flex-th num-th num-cell">Series</div>
        <div class="flex-th num-th num-cell">Reps</div>
        <div class="flex-th num-th num-cell">Carga</div>
        <div class="flex-th num-th num-cell">Desc</div>
      </div>
    </template>
    <template v-slot:draggable>
      <div
        v-for="(exercise, index) in exercises"
        :key="exercise.id"
        class="flex-trow drag-row"
        :class="{ 'flex-circuit': exercise.is_circuit }"
        :style="getRowStyle(index)"
      >
        <template v-if="exercise.is_circuit">
          <div class="remove-routine" @click="removeElement(index)">
            <IconCross />
          </div>
          <div 
            class="flex-td circuit-td handle-td"
            @contextmenu.prevent.stop="openColorMenu($event, index)"
          >
            Circuito
          </div>
          <div
            class="flex-td name-td nested-td"
            @contextmenu.prevent.stop="openColorMenu($event, index)"
          >
            <DragTable
              class="circuit-ex-table"
              v-model="exercise.exercises"
              group="routine"
              handle=".name-nested-td"
              placeholder="Sin ejercicios"
              ref="nested-ex-table"
            >
              <template v-slot:draggable>
                <div v-for="(nestedExercise, exerciseIndex) in exercise.exercises"
                  :key="nestedExercise.id"
                  class="nested-row"
                >
                  <div class="remove-exercise" @click="removeExercise(index, exerciseIndex)">
                    <IconCross />
                  </div>
                  <div class="flex-td name-nested-td">
                    {{ nestedExercise.type.name }}
                  </div>
                </div>
              </template>
            </DragTable>
          </div>
          <div class="flex-td observation-td editable-cell">
            <EditableCellInput v-model="exercise.observation" :is-textarea="true" />
          </div>
          <div class="flex-td num-td num-cell editable-cell" :key="index+'s'">
            <EditableCellInput v-model="exercise.series" inputType="number" />
          </div>
          <div class="flex-td num-td num-cell editable-cell nested-td" :key="index+'r'">
            <div v-for="(nestedExercise, exerciseIndex) in exercise.exercises"
              :key="nestedExercise.id"
              class="nested-row"
            >
              <div class="flex-td num-td num-cell editable-cell rep-nested-td">
                <EditableCellInput v-model="nestedExercise.repetitions" inputType="number" />
              </div>
            </div>
          </div>
          <div class="flex-td num-td num-cell editable-cell with-unit" :key="index+'l'">
            <EditableCellInput v-model="exercise.load_amount" inputType="number" />
            <EditableCellSelect
              v-model="exercise.load_measurement"
              :units="['RER', 'kgs','lbs','grs', 'segs']"
            />
          </div>
          <div class="flex-td num-td num-cell editable-cell with-unit disabled" :key="index+'b'">
            <EditableCellInput v-model="exercise.break_secs" inputType="number" />
            <EditableCellSelect :disabled="true" value="seg" />
          </div>
        </template>
        <template v-else>
          <div class="remove-routine" @click="removeElement(index)">
            <IconCross />
          </div>
          <div 
            class="flex-td circuit-td handle-td"
            @contextmenu.prevent.stop="openColorMenu($event, index)"
          >
            -
          </div>
          <div
            class="flex-td name-td handle-td"
            @contextmenu.prevent.stop="openColorMenu($event, index)"
          >{{ exercise.type.name }}</div>
          <div class="flex-td observation-td editable-cell">
            <EditableCellInput v-model="exercise.observation" :is-textarea="true" />
          </div>
          <div class="flex-td num-td num-cell editable-cell" :key="index+'s'">
            <EditableCellInput v-model="exercise.series" inputType="number" />
          </div>
          <div class="flex-td num-td num-cell editable-cell" :key="index+'r'">
            <EditableCellInput v-model="exercise.repetitions" inputType="number" />
          </div>
          <div class="flex-td num-td num-cell editable-cell with-unit" :key="index+'l'">
            <EditableCellInput v-model="exercise.load_amount" inputType="number" />
            <EditableCellSelect
              v-model="exercise.load_measurement"
              :units="['RER', 'kgs','lbs','grs', 'segs']"
            />
          </div>
          <div class="flex-td num-td num-cell editable-cell with-unit disabled" :key="index+'b'">
            <EditableCellInput v-model="exercise.break_secs" inputType="number" />
            <EditableCellSelect :disabled="true" value="seg" />
          </div>
        </template>
      </div>
    </template>
  </DragTable>
</template>

<script>
import { keyMixin } from "../../mixins/keyMixin";
import { getCorrectedColorName, getColorContrast } from "../../utils";
import DragTable from "./base/DragTable";
import EditableCellInput from "../EditableCellInput";
import EditableCellSelect from "../EditableCellSelect";
import IconCross from "../icon/IconCross";

export default {
  name: "RoutineTable",
  components: { IconCross, DragTable, EditableCellInput, EditableCellSelect },
  model: {
    prop: "exercises",
    event: "change"
  },
  mixins: [keyMixin],
  props: {
    exercises: {
      type: Array,
      default: function() {
        return [];
      }
    },
    title: {
      type: String,
      default: "Musculación"
    },
    routine: {
      type: String,
    }
  },
  data: function() {
    return {
      dataExercises: this.exercises,
    };
  },
  mounted() {
    // deprecated behaviour
  },
  methods: {
    removeElement: function(index) {
      this.dataExercises.splice(index, 1);
    },
    removeExercise: function(circuit, index) {
      this.dataExercises[circuit].exercises.splice(index, 1);
    },
    dragAdd: function(index) {
      //pass
    },
    addCircuit: function() {
      this.dataExercises.unshift(
        {
          id: this.random_key(),
          is_circuit: true,
          color: '#ffffff',
          order: 1,
          exercises: [],
          observation: "Circuito inicial",
          series: null,
          load_amount: null,
          load_measurement: null,
          break_secs: null,
        }
      )
    },
    getRowStyle: function(rowIndex) {
      const style = {};
      const rowColor = this.dataExercises[rowIndex].color;
      style.backgroundColor = getCorrectedColorName(rowColor);
      style.color = getColorContrast(rowColor) < 0 ? "#333" : "#FFF";
      return style;
    },
    openColorMenu(event, rowIndex) {
      this.$store.commit("contextMenu/setOpen", true);
      this.$store.commit("contextMenu/setPosition", {
        x: event.pageX,
        y: event.pageY
      });
      this.$store.commit("contextMenu/setTarget", this.dataExercises[rowIndex]);
    }
  },
  watch: {
    dataExercises: function(val) {
      this.$emit("change", val);
    },
  },
  computed: {}
};
</script>

<style scoped lang="scss">
$routine-table-base-color: $dark-blue;
$routine-table-title-bg-color: $routine-table-base-color;
$routine-table-title-color: $white;
$routine-table-header-bg-color: rgba($routine-table-base-color, 0.1);
$routine-table-header-color: $routine-table-base-color;

.routine-table {
  overflow-x: auto;
  padding: 4px;
  width: 100%;
  flex-direction: column;
}

.circuit-ex-table {
  width: 100%;
  flex-direction: column;
}

.flex-th.table-title {
  background-color: $routine-table-title-bg-color;
  color: white;
  position: sticky;
  left: 0;
  width: 100%;
  padding: 0.5rem;
}

.flex-th {
  background-color: $routine-table-header-bg-color;
  color: $routine-table-header-color;
  padding: 0.25rem;
}

.name-td,
.name-th {
  justify-content: flex-start;
  text-align: left;
  padding-left: 40px;
  flex: 1 0 12.5rem; 
}

.circuit-th,
.circuit-td {
  justify-content: center;
  text-align: left;
  flex: 1 0 6rem;
}

.observation-td,
.observation-th {
  justify-content: flex-start;
  text-align: left;
  flex: 1 0 12.5rem;

  & textarea {
    text-align: left;
    height: 100% !important;
  }
}

.observation-th {
  padding-left: 1rem;
}

.handle-td,
.name-nested-td {
  cursor: move;
}

.num-td,
.num-th {
  flex: 1 0 4.5rem; 
}

.nested-td {
  flex-flow: column wrap;
  justify-content: center;
  padding: 0px;

  & .nested-row {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    width: 100%;
    flex: 1 0 1rem;

    & .flex-td {
      border-right: 0px;
      border-left: 0px;
    }

    & .name-nested-td, .rep-nested-td {
      width: 100%;
      flex: 1 0 1rem;
    }

    & .name-nested-td {
      justify-content: flex-start;
      text-align: left;
      padding-left: 40px;
    }
  }
}

.flex-trow-header.with-week-title {
  height: unset;

  & .flex-th {
    font-weight: normal;
    font-size: $font-size-sm;
    font-style: italic;
  }
}

.drag-row.flex-trow,
.nested-row {
  position: relative;
  min-height: $routine-row-min-height;
  min-width: fit-content;
}

.drag-chosen .flex-td:not(.name-td):not(.name-nested-td) {
  opacity: 0.25;
}
.nested-td .flex-trow.drag-chosen .flex-td:not(.name-td) {
  display: none;
}

.flex-trow .remove-routine,
.nested-row .remove-exercise {
  display: none;
  position: absolute;
  margin: -0.5px;
  height: 100%;
  align-items: center;
  width: 2rem;
  justify-content: center;
  color: inherit;

  & svg {
    width: 1rem;
    margin-top: 0.1rem;
    opacity: 0.5;
  }

  &:after {
    content: "";
    display: block;
    background-color: currentColor;
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0.1;
  }
}

.flex-trow:hover .remove-routine,
.nested-row:hover .remove-exercise {
  display: flex;
  cursor: pointer;
}

.num-cell input {
  padding: 0;
}

.editable-cell {
  & input,
  & textarea,
  & input::placeholder,
  & textarea::placeholder {
    color: inherit;
  }
}

.with-unit {
  position: relative;

  & input {
    padding-bottom: 1rem;
  }

  & select {
    display: block;
    opacity: 0.5;
    color: inherit;
    font-size: $font-size-sm;
    position: absolute;
    top: 50%;
    line-height: 1.3em;

    &:hover:not([disabled]) {
      opacity: 1;
    }

    &:hover[disabled] {
      background-color: transparent;
      cursor: unset;
    }

    &:active,
    &:focus {
      opacity: 1;
      background-color: $active-background-color;
    }
  }
}

.routine-btnbar-group {
  position: absolute;
  display: flex;
  align-items: center;

  &.left-group {
    left: 0.5rem;
  }

  &.right-group {
    right: 0.5rem;
  }

  & span {
    font-weight: normal;
    font-size: $font-size-sm;
    margin: 0 0.3rem 0;
  }

  & button {
    margin: 0 map_get($spacers, 1);
    width: 1.5rem;
    height: 1.5rem;
    padding: 0.2rem 0.2rem 0.4rem;
    line-height: 0;
    font-weight: bold;
  }
}

// Hide incremental arrows
/* Chrome, Safari, Edge, Opera */
.editable-cell input::-webkit-outer-spin-button,
.editable-cell input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.editable-cell input[type="number"] {
  -moz-appearance: textfield;
}
</style>

<style lang="scss">
.routine-table {
  & > .flex-tcol {
    flex-basis: 100%;
  }

  & .drag-content .transition-group {
    display: flex;
    flex-direction: column;
    width: auto;
  }
}
</style>